export const ROLE_ADMIN = "ROLE_ADMIN";
export const ROLE_VLN = "ROLE_VLN";
